const ContactUs = () => {
  return (
    <div>
      <h2>Contact Us</h2>
      <p>
        If you have any questions, feedback, or inquiries, please feel free to
        reach out to us. We are here to assist you!
      </p>
      <div>
        <h3>Customer Support</h3>
        <p>For any support-related questions or assistance:</p>
        <ul>
          <li>Email: support@foodexpress.com</li>
          <li>Phone: +1-123-456-7890</li>
        </ul>
      </div>
      <div>
        <h3>Business Inquiries</h3>
        <p>For business-related inquiries and partnerships:</p>
        <ul>
          <li>Email: partnerships@foodexpress.com</li>
          <li>Phone: +1-987-654-3210</li>
        </ul>
      </div>
      <div>
        <h3>Address</h3>
        <p>Food Express Inc.</p>
        <p>123 Main Street</p>
        <p>City, State, ZIP</p>
        <p>Country</p>
      </div>
    </div>
  );
};

export default ContactUs;
